import {
  faBadgeCheck,
  faCheckCircle,
  faCircleInfo,
  faCirclePause,
  faClock,
  faXmark
} from "@fortawesome/pro-regular-svg-icons";
import {
  faArrowRightFromBracket,
  faArrowsRotate,
  faBan,
  faBell,
  faBuilding,
  faCalendarAlt,
  faCalendarClock,
  faCheck,
  faCheckDouble,
  faCircleHalfStroke,
  faClockRotateLeft,
  faCoinBlank,
  faCoins,
  faCopy,
  faDoorOpen,
  faDownload,
  faEnvelopeOpenDollar,
  faEuroSign,
  faExclamation,
  faExclamationTriangle,
  faEye,
  faFile,
  faFileContract,
  faFileExcel,
  faFileImage,
  faFilePdf,
  faFilePowerpoint,
  faFileWord,
  faFilter,
  faGauge,
  faGrip,
  faHandHoldingDollar,
  faInbox,
  faMoneyBillTransfer,
  faPaperPlane,
  faPiggyBank,
  faPlus,
  faQuestion,
  faRotateLeft,
  faSack,
  faSackDollar,
  faSackXmark,
  faSearch,
  faSignature,
  faTimes,
  faTrashCan,
  faTriangleExclamation,
  faUndo,
  faUser,
  faUsers,
  faUserTie,
  faXmarkToSlot
} from "@fortawesome/pro-solid-svg-icons";

const icons = [
  faUsers,
  faUser,
  faSearch,
  faFileContract,
  faBuilding,
  faPaperPlane,
  faEuroSign,
  faCheck,
  faTimes,
  faCalendarAlt,
  faDownload,
  faUserTie,
  faPiggyBank,
  faCheckCircle,
  faClock,
  faBell,
  faBadgeCheck,
  faCircleHalfStroke,
  faCopy,
  faFilter,
  faGauge,
  faCoinBlank,
  faCoins,
  faSack,
  faEye,
  faCheckDouble,
  faSignature,
  faArrowRightFromBracket,
  faHandHoldingDollar,
  faDoorOpen,
  faUndo,
  faBan,
  faFile,
  faFileExcel,
  faFileImage,
  faFilePdf,
  faFilePowerpoint,
  faFileWord,
  faInbox,
  faQuestion,
  faXmark,
  faTrashCan,
  faPlus,
  faGrip,
  faExclamationTriangle,
  faExclamation,
  faEnvelopeOpenDollar,
  faCalendarClock,
  faSackDollar,
  faXmarkToSlot,
  faRotateLeft,
  faTriangleExclamation,
  faSackXmark,
  faMoneyBillTransfer,
  faCircleInfo,
  faArrowsRotate,
  faClockRotateLeft,
  faCirclePause
];

const aliases = {
  notification: "fas fa-bell",
  theme: "fas fa-circle-half-stroke",
  filter: "fas fa-filter",

  preScans: "fas fa-grip",
  funder: "fas fa-piggy-bank",
  consumer: "fas fa-user",
  business: "fas fa-building",
  user: "fas fa-user",
  search: "fas fa-search",
  dashboard: "fas fa-gauge",
  financeReceiver: "fas fa-hand-holding-usd",

  fundingContract: "fas fa-file-contract",

  financeReceiverStatusPreScanSubmitted: "fas fa-inbox",
  financeReceiverStatusPreScanInProgress: "far fa-clock",
  financeReceiverStatusPreScanRejected: "fas fa-ban",
  financeReceiverStatusPreScanWithdrawn: "fas fa-undo",
  financeReceiverStatusInactive: "fas fa-times",
  financeReceiverStatusActive: "fas fa-euro-sign",
  financeReceiverStatusDelinquent: "fas fa-exclamation-triangle",
  financeReceiverStatusDefaulting: "fas fa-exclamation",
  financeReceiverStatusOffboarded: "fas fa-door-open",

  fundingContractStatusDraft: "fas fa-pencil",
  fundingContractStatusSent: "fas fa-paper-plane",
  fundingContractStatusAccepted: "fas fa-signature",
  fundingContractStatusValidated: "fas fa-check-double",
  fundingContractStatusActive: "fas fa-euro-sign",
  fundingContractStatusInactive: "fas fa-times",

  logout: "fas fa-arrow-right-from-bracket",
  account: "fas fa-user-tie",

  Prescanstep1: "fas fa-pencil",
  Prescanstep2: "fas fa-file",
  Prescanstep3: "fas fa-coins",
  Prescanstep8: "fas fa-check-double",
  Prescanstep5: "fas fa-user",
  Prescanstep9: "fas fa-user",
  PrescanemailOption: "fas fa-question",

  true: "fas fa-check",
  false: "fas fa-times",

  calender: "fas fa-calendar-alt",
  download: "fas fa-download",
  copy: "fas fa-copy",
  open: "fas fa-eye",

  filePdf: "fas fa-file-pdf",
  fileWord: "fas fa-file-word",
  fileExcel: "fas fa-file-excel",
  fileImage: "fas fa-file-image",
  filePowerpoint: "fas fa-file-powerpoint",

  waiting: "far fa-clock",
  done: "far fa-check-circle",

  warning: "fas fa-triangle-exclamation",

  tasksDone: "far fa-badge-check",

  delete: "fas fa-trash-can",
  add: "fas fa-plus",

  bronzePartner: "fas fa-coin-blank",
  silverPartner: "fas fa-coins",
  goldPartner: "fas fa-sack",

  loanStatusRequested: "fas fa-envelope-open-dollar",
  loanStatusApproved: "fas fa-calendar-clock",
  loanStatusApprovedRenewal: "fas fa-calendar-clock",
  loanStatusApprovedAndPaid: "fas fa-sack-dollar",
  loanStatusRejected: "fas fa-xmark-to-slot",
  loanStatusCompletedAndRefunded: "fas fa-rotate-left",
  loanStatusDefaulting: "fas fa-triangle-exclamation",
  loanStatusIrrecoverable: "fas fa-sack-xmark",
  loanStatusDirectDebitProcessing: "fas fa-money-bill-transfer",
  loanRenewal: "fas fa-arrows-rotate",
  loanEarlyRepayment: "fas fa-clock-rotate-left",
  loanHasPausedExtraCosts: "far fa-circle-pause",

  directDebitStatusScheduled: "far fa-clock",
  directDebitStatusSuccessful: "fas fa-check",
  directDebitStatusFailed: "fas fa-triangle-exclamation",
  directDebitStatusCancelled: "fas fa-times",
  directDebitStatusProcessing: "fas fa-money-bill-transfer",

  isCollectionDateUpcoming: "far fa-circle-info"
};

export default {
  aliases,
  icons
};
